<template>
  <div>
    <div class="p-6 pt-0">
      <vs-table
        id="sarai-list"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="800px"
        @search="updateSearchQuery"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        :max-items="length"
        search
        :data="records"
      >
        <template slot="header">
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) || 0 }} -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }} of {{ total || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)"><span>10</span></vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)"><span>20</span></vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)"><span>50</span></vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)"><span>100</span></vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
              <div class="flex flex-wrap items-center">
                <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5" class="mt-1"></vs-pagination>
              </div>
              <vs-button @click="toggleAddModal" color="primary" size="default" style="padding: 12px 30px">
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" /> Add Sarai
              </vs-button>
            </div>
          </div>
          </template>

          <template slot="thead">
            <vs-th>Sr#</vs-th>
            <vs-th>Sarai Name</vs-th>
            <vs-th>Gurudwara</vs-th>
            <vs-th>Rooms</vs-th>
            <vs-th>Status</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
              <vs-td>{{ page * length - (length - i - 1) }}</vs-td>
              <vs-td class="text-left">
                <span class="cursor-pointer" @click.stop="toggleEditModal(tr)">{{ tr.name || '-' }}</span>
              </vs-td>
              <vs-td class="text-left">
                <span>{{ tr.gurudwara.name || '-' }}</span>
              </vs-td>
              <vs-td>
                <span>{{ (tr.rooms && tr.rooms.length) || 0 }} rooms</span>
              </vs-td>
              <vs-td>
                <vs-switch
                  icon-pack="feather"
                  vs-icon-on="icon-check-circle"
                  vs-icon-off="icon-slash"
                  color="primary"
                  :value="tr.is_active"
                  @click.stop="updateStatus(tr._id, !tr.is_active)"
                >
                  <span slot="on"></span>
                  <span slot="off"></span>
                </vs-switch>
              </vs-td>
              <vs-td>
                <div class="inline-flex">
                  <vx-tooltip text="Edit Sarai">
                    <feather-icon
                      @click.stop="toggleEditModal(tr)"
                      icon="EditIcon"
                      svgClasses="h-6 w-6 mr-4 hover:text-primary cursor-pointer"
                    />
                  </vx-tooltip>
                  <vx-tooltip text="Delete Sarai">
                    <feather-icon @click.stop="deleteRecord(tr._id)" icon="TrashIcon" svgClasses="h-6 w-6 mr-4 hover:text-primary cursor-pointer" />
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>

      <!-- Add/Edit Modal -->
      <action-modal
        v-if="isAddModalMounted || isEditModalMounted"
        @update-data="getData"
        :showModal.sync="showModal"
        :selectedRecordId="selectedRecordId"
        :selectedRecordData="selectedRecordData"
        :action_name="isAddModalShow ? 'Add' : 'Update'"
      />
    </div>
</template>

<script>
import axios from '@/axios'
import ActionModal from './action.vue'

export default {
  name: 'SaraiList',
  components: {
    'action-modal': ActionModal
  },
  data() {
    return {
      records: [],
      FilteredCount: 0,
      total: 0,
      page: 1,
      length: 10,
      searchQuery: '',
      isAddModalShow: false,
      isEditModalShow: false,
      isAddModalMounted: false,
      isEditModalMounted: false,
      selectedRecordId: null,
      selectedRecordData: null
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    },
    showModal: {
      get() {
        return this.isAddModalShow || this.isEditModalShow
      },
      set(value) {
        if (!value) {
          this.isAddModalShow = false
          this.isEditModalShow = false
        }
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      try {
        const params = {
          page: this.page,
          limit: this.length,
          search: this.searchQuery
        }
        const response = await axios.get('/admin/sarai', { params })
        if (response.data.success) {
          this.records = response.data.data.results || []
          this.FilteredCount = response.data.data.totalResults || 0
          this.total = response.data.data.totalResults || 0
        }
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: (error.response && error.response.data && error.response.data.message) || 'Failed to fetch sarai list',
          color: 'danger'
        })
      }
    },
    updateSearchQuery(query) {
      this.searchQuery = query
      this.page = 1
      this.getData()
    },
    handleChangePage(page) {
      this.page = page
      this.getData()
    },
    handleChangeLength(length) {
      this.length = length
      this.page = 1
      this.getData()
    },
    handleSort(key, active) {
      // Handle sorting if needed
      this.getData()
    },
    toggleAddModal() {
      this.isAddModalMounted = true
      this.isAddModalShow = true
      this.selectedRecordId = null
      this.selectedRecordData = null
    },
    toggleEditModal(record) {
      this.isEditModalMounted = true
      this.isEditModalShow = true
      this.selectedRecordId = record._id
      this.selectedRecordData = record
    },
    async updateStatus(id, status) {
      try {
        await axios.put(`/admin/sarai/${id}`, { is_active: status })
        this.$vs.notify({
          title: 'Success',
          text: 'Status updated successfully',
          color: 'success'
        })
        this.getData()
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: (error.response && error.response.data && error.response.data.message) || 'Failed to update status',
          color: 'danger'
        })
      }
    },
    async deleteRecord(id) {
      if (!confirm('Are you sure you want to delete this sarai?')) return

      try {
        await axios.delete(`/admin/sarai/${id}`)
        this.$vs.notify({
          title: 'Success',
          text: 'Sarai deleted successfully',
          color: 'success'
        })
        this.getData()
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: (error.response && error.response.data && error.response.data.message) || 'Failed to delete sarai',
          color: 'danger'
        })
      }
    }
  }
}
</script>

